import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static values = {
    createUrl: String
  }

  async create(event) {
    event.preventDefault()

    const { input, callback } = event.detail

    const response = await post(this.createUrlValue, {
      body: { label: input }
    })

    const data = await response.json

    callback({ value: data.id, text: input })
  }
}
